export default "__VITE_ASSET__C8Q8jBau__"